export default __webpack_public_path__ + "static/media/604.0464cc2b.jpg";